import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Icon from '../Icon/index.js';
import { Link } from 'react-router-dom';

var _excluded = ["index", "iconName", "iconSize", "onClick", "url", "text", "theme", "externalLink"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledLink = styled('a')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: calc(100px + ((240 - 100) * (100vw - 768px)) / 1650);\n  font-weight: 400;\n  font-style: normal;\n  font-size: max(calc(0.75rem + (4 * (100vw - 768px)) / 882), 1rem);\n  color: ", ";\n  align-items: center;\n  padding: 4% 1% 1% 1%;\n  text-align: center;\n  justify-content: start;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  transition: background 0.4s;\n  border-top: ", " solid 1px;\n  border-right: ", " solid 1px;\n  border-bottom: ", " solid 1px;\n  &:first-child {\n    border-left: ", " solid 1px;\n  }\n  &:hover {\n    background: ", ";\n    text-decoration: none;\n  }\n  @media (max-width: 768px) {\n    border: ", " solid 1px;\n    border-bottom: none;\n    &:last-child {\n      border-bottom: ", " solid 1px;\n    }\n    flex-direction: row;\n    min-height: 95px;\n    font-size: 1rem;\n    justify-content: flex-start;\n    padding: 3%;\n    text-align: left;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette['secondaryDark'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette['grayLighter'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette['grayLighter'];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette['grayLighter'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette['grayLighter'];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette['grayLightest'];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette['grayLighter'];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette['grayLighter'];
});
var StyledIcon = styled(_Icon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: calc(2rem + ((35 - 32) * (100vw - 768px)) / 882);\n\n  @media (max-width: 768px) {\n    font-size: 2.2rem;\n  }\n"])));
var StyledIconContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-bottom: 0.25rem;\n\n  @media (max-width: 768px) {\n    font-size: 2.2rem;\n    position: relative;\n    justify-content: center;\n    min-width: 2.6rem;\n    width: 10%;\n  }\n"])));
var StyledLinkContainer = styled('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  @media (max-width: 768px) {\n    font-size: 1.25rem;\n  }\n"])));
var CardItem = function CardItem(_ref9) {
  var _ref9$index = _ref9.index,
    index = _ref9$index === void 0 ? 0 : _ref9$index,
    iconName = _ref9.iconName,
    iconSize = _ref9.iconSize,
    onClick = _ref9.onClick,
    url = _ref9.url,
    text = _ref9.text,
    theme = _ref9.theme,
    _ref9$externalLink = _ref9.externalLink,
    externalLink = _ref9$externalLink === void 0 ? false : _ref9$externalLink,
    rest = _objectWithoutProperties(_ref9, _excluded);
  var linkProps = externalLink ? {
    href: url
  } : {
    to: url
  };
  var Component = externalLink ? 'a' : Link;
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    as: Component,
    onClick: onClick,
    key: "banner-item-".concat(index),
    theme: theme
  }, linkProps, rest), iconName && /*#__PURE__*/React.createElement(StyledIconContainer, null, /*#__PURE__*/React.createElement(StyledIcon, {
    name: iconName,
    className: 'mr-2 mr-md-0',
    color: 'primary',
    theme: theme,
    size: iconSize || '2.5rem',
    "aria-hidden": true
  })), /*#__PURE__*/React.createElement(StyledLinkContainer, null, text));
};
var _CardItem = withDefaultTheme(CardItem);

export default _CardItem;
